import styled from "styled-components";

export const DualImageUploadWrapper = styled.div`
    width: 100%;
    margin-bottom: 30px;

    .section-title {
        font-size: 20px;
        line-height: 24px;
        font-weight: 600;
        color: var(--matte-black);
        margin-bottom: 16px;
    }

    .upload-container {
        display: grid;
        grid-template-columns: 1fr;
        gap: 20px;

        @media (min-width: 768px) {
            grid-template-columns: repeat(2, 1fr);
        }
    }
`;

export const ImageUploadBox = styled.div`
    width: 100%;
    position: relative;

    .upload-label {
        display: flex;
        align-items: center;
        justify-content: center;
        width: 100%;
        min-height: 250px;
        cursor: pointer;
        background: rgba(70, 80, 69, 0.05);
        border-radius: 16px;
        border: 2px dashed #c2c9d1;
        transition: all 0.3s ease;
        position: relative;
        overflow: hidden;

        &:hover {
            border-color: ${({theme}) => theme?.light?.primary || "#8527c4"};
            background: rgba(70, 80, 69, 0.08);
        }

        .upload-content {
            text-align: center;
            padding: 20px;

            .upload-icon {
                display: block;
                width: 50px;
                height: auto;
                margin: 0 auto 15px;
            }

            .upload-title {
                font-size: 16px;
                line-height: 20px;
                font-weight: 500;
                color: var(--matte-black);
                margin-bottom: 8px;
            }

            .upload-info {
                font-size: 12px;
                line-height: 16px;
                font-weight: 300;
                color: #666;
                margin-bottom: 4px;
            }
        }

        .preview-container {
            width: 100%;
            height: 100%;
            display: flex;
            align-items: center;
            justify-content: center;

            .preview-image {
                max-width: 100%;
                max-height: 250px;
                object-fit: contain;
                border-radius: 12px;
            }
        }
    }
`;

export const RemoveButton = styled.button`
    position: absolute;
    top: 10px;
    right: 10px;
    width: 36px;
    height: 36px;
    border-radius: 50%;
    background: rgba(255, 255, 255, 0.95);
    border: none;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15);
    color: #ff4444;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    transition: all 0.2s ease;
    padding: 0;
    z-index: 10;

    svg {
        display: block;
    }

    &:hover {
        background: #ff4444;
        color: white;
        transform: scale(1.1);
        box-shadow: 0 4px 12px rgba(255, 68, 68, 0.3);
    }

    &:active {
        transform: scale(0.95);
    }
`;
